// Gruppierte Liste im iOS-Stil (Handoff Übergabe §4): eine Karte, Zeilen mit Trennlinie.
// IosFeldZeile = Eingabezeile mit Symbol links (Name, Anschrift, E-Mail, Telefon …).
import type { InputHTMLAttributes, ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';

export function IosGruppe({ children, ariaLabel }: { children: ReactNode; ariaLabel?: string }) {
  return (
    <div role="group" aria-label={ariaLabel} className="ios-gruppe flex flex-col overflow-hidden"
      style={{ borderRadius: 18, background: 'var(--fill)', boxShadow: 'inset 0 0 0 1px var(--line)' }}>
      {children}
    </div>
  );
}

export function IosFeldZeile({ icon: I, ...input }: { icon: Icon } & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <label className="ios-zeile flex items-center" style={{ minHeight: 48, padding: '0 14px', gap: 12 }}>
      <I aria-hidden size={17} color="var(--ink3)" className="shrink-0" />
      <input {...input} aria-label={input['aria-label'] ?? (typeof input.placeholder === 'string' ? input.placeholder : undefined)}
        className="min-w-0 flex-1" style={{ height: 46, border: 'none', outline: 'none', background: 'transparent', fontFamily: 'inherit', fontSize: 15, fontWeight: 700, color: 'var(--ink)', ...input.style }} />
    </label>
  );
}
